var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"cta-button",attrs:{"href":'/'+_vm.$lang+'/contact-us/'},on:{"click":function($event){return _vm.$router.push('/contact-us/')}}},[_vm._v(" "+_vm._s(_vm.$t('contact_us'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }